import { render, staticRenderFns } from "./Battleye.vue?vue&type=template&id=5e26ac2f&scoped=true"
import script from "./Battleye.vue?vue&type=script&lang=ts"
export * from "./Battleye.vue?vue&type=script&lang=ts"
import style0 from "./Battleye.vue?vue&type=style&index=0&id=5e26ac2f&prod&lang=scss&scoped=true"
import style1 from "./Battleye.vue?vue&type=style&index=1&id=5e26ac2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e26ac2f",
  null
  
)

export default component.exports